const FARABOURSE_LICENSE_GUID = '35b7883c-a827-484f-8918-65a504a547ff'

const appDetails = {
  title: 'زیما',
  description: 'سامانه ی تامین مالی جمعی زیما',
  url: 'https://zeema.fund',
  twitterUserName: '@zeema',
  category: 'crowdfunding',
  ogImageURL: '/og.png',
  enamadCode: 'i2DdDNQ1e6n30LxxkCcw',
  enamadURL: 'https://trustseal.enamad.ir/?id=270506&Code=i2DdDNQ1e6n30LxxkCcw',
  enamadImageURL:
    'https://trustseal.enamad.ir/logo.aspx?id=270506&Code=i2DdDNQ1e6n30LxxkCcw',
  faraboorsCode: 'rgvlgwmdxlaphwlabrgw',
  faraboorsURL: `https://cf.ifb.ir/report/PlatformActivityLicenseTrustSealDetail?licenseguid=${FARABOURSE_LICENSE_GUID}`,
  faraboorsImageURL: '/images/footer/fara-bourse.svg',
  sejamURL: 'https://profilesejam.csdiran.ir/session',
  sejamChoosePlanURL: 'https://profilesejam.csdiran.ir',
  faraboorsPublicLink: 'https://www.ifb.ir/Finstars/AllCrowdFundingAgents.aspx',
  saderatPublicLink: 'https://saderatbourse.ir/',
  supportPhone: '02192008828',
  supportPhoneLabel: '021-92008828',
  supportPhoneLabelRTL: '92008828-021',
  instagramURL:
    'https://www.instagram.com/zeema.fund?igsh=MW9xNzJydW51aDFvOQ==',
  linkedInURL: 'https://www.linkedin.com/company/zeemafund/',
  telegramURL: 'https://t.me/zeemacrowd',
  emailURL: 'Info@zeema.fund',
  gtmId: 'GTM-NF8Z4MG6',
}

export { appDetails }
